import { makeStyles } from '@material-ui/core';
import { colors } from 'design-system';

export type CustomButtonColor = {
  default: string;
  hover: string;
  active: string;
  background?: string;
};

export const useCardStyle = makeStyles(() => ({
  cardRoot: {
    paddingTop: 20,
    paddingBottom: 15,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
  },
}));

export const useStyle = makeStyles(() => ({
  baseButton: {
    borderRadius: 25,
    fontWeight: 'bold',
    fontSize: 12,
    fontStyle: 'normal',
    lineHeight: '14px',
    letterSpacing: '1.3px',
    paddingInline: '0.8rem',
    height: 30,
  },
  outlinedButton: (usedColor: CustomButtonColor) => ({
    backgroundColor: usedColor.background,
    color: usedColor.default,
    border: `1px solid ${usedColor.default}`,
    '&:hover': {
      color: usedColor.default,
      backgroundColor: 'rgba(0, 194, 255, 0.12)',
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      border: `1px solid ${colors.silver}`,
      color: colors.silver,
    },
    '&:active': {
      backgroundColor: 'rgba(23, 73, 160, 0.12)',
      color: usedColor.active,
      border: `1px solid ${usedColor.active}`,
    },
  }),
  container: {
    marginTop: '1rem',
  },
  titleText: {
    fontSize: 19,
    fontWeight: 900,
  },
  titleSection: { paddingBottom: 7 },
  logo: { marginRight: 11 },
}));
